// NPM Imports
import React, { Fragment } from "react";
import Modal from "react-responsive-modal";
import ReactHtmlParser from "react-html-parser";
import { Button } from "@revvsales/components";

// import Iframe from "react-iframe";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

// Component Imports

// Internal Imports
import { NAVBAR, EVENTS } from "../../constants";
import { GlobalUtils, AmplitudeUtils } from "../../utils";

// Destructuring
const { ONBOARD_TEXT } = NAVBAR;
const { writeDataToLocalStorage, readDataFromLocalStorage } = GlobalUtils;
const { amplitudeLogEvent } = AmplitudeUtils;

export default function OnBoardPopUp(props) {
  // * AMPLITUDE SECTION
  amplitudeLogEvent(EVENTS.EVENT_NAMES.GO_TO_POPUP_CLICKED, {
    Feature: props.featureName,
  });

  // * FUNCTION SECTION
  function _onBtnClick() {
    const checklist = readDataFromLocalStorage("onBoardCheckList");
    if (checklist) {
      const checkListClone = JSON.parse(JSON.stringify(checklist));
      checkListClone[props.featureName] = false;
      writeDataToLocalStorage("onBoardCheckList", checkListClone);
    }
    props.onClose();
  }

  // * COMPONENT SECTION
  if (
    props.featureName &&
    Object.prototype.hasOwnProperty.call(ONBOARD_TEXT, props.featureName)
  ) {
    const {
      title,
      subTitle,
      videoUrl,
      ico,
      pageName,
      featureDescription,
      features,
      btnTxt,
      link,
    } = ONBOARD_TEXT[props.featureName];
    return (
      <Modal
        open
        onClose={props.onClose}
        center
        closeOnOverlayClick={false}
        classNames={{ modal: "onboardpopup-modal-box" }}>
        <div className="onboardpopup-container">
          <section className="onboardpopup-header">
            <div className="onboardpopup-title">{title}</div>
            <div className="onboardpopup-sub-title">{subTitle}</div>
          </section>

          <section className="onboardpopup-body">
            <div className="onboardpopup-left-section">
              <iframe
                title="Product Sale Video"
                src={`${videoUrl}&autoplay=1&modestbranding=0&autohide=1&showinfo=0`}
                id="onboardpopup-youtube-iframe"
                className="onboardpopup-iframe"
                frameBorder="0"
              />
            </div>
            <div className="onboardpopup-right-section">
              <div className="onboardpopup-title-section ">
                <span className="onboardpopup-ico-wrapper">
                  <i className="onboardpopup-ico">
                    <FontAwesomeIcon icon={["far", `${ico}`]} />
                  </i>
                  <span className="onboardpopup-play-ico">
                    <FontAwesomeIcon icon={["fas", "play-circle"]} />
                  </span>
                </span>
                <span className="onboardpopup-page-name">{pageName}</span>
              </div>
              <div className="onboardpopup-feature-desc">
                {ReactHtmlParser(featureDescription)}
              </div>
              <div className="onboardpopup-feature-list">
                {features.map(feature => (
                  <span key={feature}>
                    {"-"}&nbsp;
                    {ReactHtmlParser(feature)}
                  </span>
                ))}
              </div>
            </div>
          </section>
          <section className="onboardpopup-footer modal-footer">
            <Link to={link}>
              <Button
                data-test="upgrade-my-plan-button"
                className="onboardpopup-btn"
                onClick={_onBtnClick}>
                {btnTxt}
              </Button>
            </Link>
          </section>
        </div>
      </Modal>
    );
  }
  return <Fragment />;
}



// WEBPACK FOOTER //
// ./src/commonComponents/OnBoardPopUp/index.js